var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForbidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 135,
    viewBox: "0 0 128 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.3 109.7C98.3 109.7 121 87 121 58.9C121 30.8 98.2 8.09998 70.3 8.09998C42.3 8.09998 19.6 30.8 19.6 58.9C19.6 87 42.3 109.7 70.3 109.7Z",
    fill: "#E6EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.7 25.6C119.964 25.6 121.8 23.7644 121.8 21.5C121.8 19.2357 119.964 17.4 117.7 17.4C115.435 17.4 113.6 19.2357 113.6 21.5C113.6 23.7644 115.435 25.6 117.7 25.6Z",
    fill: "#E5EDFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.7 9.6C125.247 9.6 126.5 8.3464 126.5 6.8C126.5 5.2536 125.247 4 123.7 4C122.154 4 120.9 5.2536 120.9 6.8C120.9 8.3464 122.154 9.6 123.7 9.6Z",
    fill: "#E5EDFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 25.5C23.8464 25.5 25.1 24.2464 25.1 22.7C25.1 21.1536 23.8464 19.9 22.3 19.9C20.7536 19.9 19.5 21.1536 19.5 22.7C19.5 24.2464 20.7536 25.5 22.3 25.5Z",
    fill: "#E5EDFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 79.5C8.07188 79.5 10.4 77.1719 10.4 74.3C10.4 71.4281 8.07188 69.1 5.2 69.1C2.32812 69.1 0 71.4281 0 74.3C0 77.1719 2.32812 79.5 5.2 79.5Z",
    fill: "#E5EDFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3457_25543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.8 33.5L105.6 97.9C105.6 100.1 103.8 101.8 101.6 101.8H38.8C36.6 101.8 34.8 100 34.8 97.9V15.1C34.8 12.9 36.6 11.2 38.8 11.2H84.3L104.8 33.5Z",
    fill: "url(#paint0_linear_3457_25543)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4 88.9H53.1C52.6 88.9 52.2 88.4 52.2 87.8C52.2 87.2 52.6 86.7 53.1 86.7H65.4C65.9 86.7 66.3 87.2 66.3 87.8C66.3 88.5 65.9 88.9 65.4 88.9Z",
    fill: "#E5EDFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4 88.9H45C44.5 88.9 44.1 88.4 44.1 87.8C44.1 87.2 44.5 86.7 45 86.7H58.4C58.9 86.7 59.3 87.2 59.3 87.8C59.3 88.5 58.9 88.9 58.4 88.9Z",
    fill: "#E5EDFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 24.7H45.4C44.7 24.7 44.1 24.1 44.1 23.4C44.1 22.7 44.7 22.1 45.4 22.1H75.5C76.2 22.1 76.8 22.7 76.8 23.4C76.8 24.1 76.2 24.7 75.5 24.7Z",
    fill: "#E5EDFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31.9H45.4C44.7 31.9 44.1 31.3 44.1 30.6C44.1 29.9 44.7 29.3 45.4 29.3H56.9C57.6 29.3 58.2 29.9 58.2 30.6C58.2 31.3 57.6 31.9 57 31.9Z",
    fill: "#E5EDFE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3 11.2V29C84.3 31.5 86.5 33.5 89 33.5H104.8",
    fill: "#E5EDFE"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8615 71.595H61.1654H57.3413H45.776C45.3096 71.595 44.8433 72.0623 44.8433 72.7166C44.8433 73.2774 45.2163 73.8382 45.776 73.8382H57.3413H61.1654H95.8615C96.3279 73.8382 96.7942 73.3708 96.7942 72.7166C96.701 72.0623 96.3279 71.595 95.8615 71.595Z",
    fill: "#E5EDFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7683 63.4633H82.8971H78.5135H45.776C45.3096 63.4633 44.8433 63.9306 44.8433 64.5849C44.8433 65.1457 45.2163 65.7065 45.776 65.7065H78.5135H82.8971H95.7683C96.2346 65.7065 96.701 65.2391 96.701 64.5849C96.6077 63.9306 96.2346 63.4633 95.7683 63.4633Z",
    fill: "#E5EDFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0481 55.2382H92.6904H89.3327H45.776C45.3096 55.2382 44.8433 55.7055 44.8433 56.3598C44.8433 56.9206 45.2163 57.4814 45.776 57.4814H89.3327H93.0635H95.9548C96.4212 57.4814 96.8875 57.014 96.8875 56.3598C96.9808 55.799 96.5144 55.2382 96.0481 55.2382Z",
    fill: "#E5EDFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4865 89.7276H45.776C45.3096 89.7276 44.8433 89.2603 44.8433 88.606C44.8433 88.0452 45.2163 87.4844 45.776 87.4844H59.4865C59.9529 87.4844 60.4192 87.9517 60.4192 88.606C60.4192 89.3537 59.9529 89.7276 59.4865 89.7276Z",
    fill: "#E3EAF2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4211 47.1066H85.5086H82.8038H45.776C45.3096 47.1066 44.8433 47.5739 44.8433 48.2282C44.8433 48.789 45.2163 49.3498 45.776 49.3498H82.8038H85.5086H96.3279C96.9808 49.3498 97.3538 48.8824 97.3538 48.2282C97.3538 47.6674 96.9808 47.1066 96.4211 47.1066Z",
    fill: "#E5EDFE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5221 94.6814H24.5106C22.0856 94.6814 20.127 92.7186 20.127 90.2885V59.7246C20.127 51.2191 27.0289 44.396 35.4231 44.396C43.8173 44.396 50.7193 51.3126 50.7193 59.7246V90.3819C50.8125 92.7186 48.8539 94.6814 46.5221 94.6814ZM28.8943 85.989H42.1385V59.7246C42.1385 56.0794 39.1539 53.0885 35.5164 53.0885C31.8789 53.0885 28.8943 56.0794 28.8943 59.7246V85.989Z",
    fill: "#0057FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5692 103H15.7433C13.0385 103 10.8 100.757 10.8 98.0463V71.595C10.8 68.8845 13.0385 66.6412 15.7433 66.6412H55.5692C58.2741 66.6412 60.5125 68.8845 60.5125 71.595V98.0463C60.5125 100.757 58.2741 103 55.5692 103Z",
    fill: "#568FFD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6462 80.7548C40.6462 82.7176 39.527 84.4 37.9414 85.2412V90.6623C37.9414 91.9708 36.9154 92.999 35.6097 92.999C34.3039 92.999 33.2779 91.9708 33.2779 90.6623V85.2412C31.6924 84.4 30.5731 82.7176 30.5731 80.7548C30.5731 77.9507 32.8116 75.7075 35.6097 75.7075C38.4077 75.7075 40.6462 77.9507 40.6462 80.7548Z",
    fill: "#0057FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3457_25543",
    x: 12.8,
    y: 0.200012,
    width: 114.8,
    height: 134.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3457_25543"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3457_25543",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3457_25543",
    x1: 70.1769,
    y1: 9.10435,
    x2: 70.1769,
    y2: 102.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbidden);
export default __webpack_public_path__ + "static/media/Forbidden.3dd2f73ce01a83f0e62070e1883842ae.svg";
export { ForwardRef as ReactComponent };